import { AppSidebar } from "@/components/app-sidebar"
import { Separator } from "@/components/ui/separator"
import { SidebarInset, SidebarTrigger } from "@/components/ui/sidebar"

export function Page({
  headerSlot,
  tabSlot,
  children,
}: {
  headerSlot?: React.ReactNode
  tabSlot?: React.ReactNode
  children: React.ReactNode
}) {
  return (
    <>
      <AppSidebar />
      <SidebarInset>
        <div className="flex flex-1 flex-col">
          <div className="@container/main flex flex-1 flex-col">
            <div className="flex items-center min-h-16 gap-2 border-b w-full px-5">
              <div className="flex items-center gap-2 px-4 shrink-0">
                <SidebarTrigger className="-ml-1" />
                <Separator
                  orientation="vertical"
                  className="mr-2 data-[orientation=vertical]:h-4"
                />
              </div>
              <header className="flex-1 flex items-center py-4">{headerSlot}</header>
            </div>
            {tabSlot}
            <div className="p-6">{children}</div>
          </div>
        </div>
      </SidebarInset>
    </>
  )
}
